

















































































































































import { Component, Watch, Mixins, Prop } from 'vue-property-decorator';
import {
  Alert,
  Button,
  Card,
  Form,
  FormItem,
  Input,
  Option,
  Radio,
  RadioGroup,
  Select
} from 'element-ui';
import Callout from '@/components/Callout.vue';
import Pagination from '@/mixins/pagination';
import FetchOrganizationStaff from '@/graphql/queries/FetchOrganizationStaffs.gql';
import { shipperService } from '@/services/ShipperService';
import { customerService } from '@/services/CustomerService';
import {
  AvailableLocalesEnum,
  CustomerOrganizationFields,
  ShipperInput,
  ShipperInvitationInput,
  organizationStaff_organizationStaff
} from '@/types/graphql/schemaTypes';
import { languageOptions } from '@/constants/languages';
import rules from '@/rules/rules';

@Component({
  apollo: {
    staff: {
      query: FetchOrganizationStaff,
      debounce: 300,
      prefetch: true,
      variables() {
        return {
          organizationArgs: {
            customerOrganizationId: this.$route.params.id,
            name: this.searchText
          },
          pagination: {
            page: parseInt(this.$route.query.page, 10) || this.currentPage,
            per: parseInt(this.$route.query.size, 10) || this.paginationSize
          }
        };
      },
      update(data) {
        this.totalCount = data.organizationStaffPagination.totalCount;
        return data.organizationStaff;
      }
    }
  },
  components: {
    Callout,
    'el-alert': Alert,
    'el-button': Button,
    'el-card': Card,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-input': Input,
    'el-option': Option,
    'el-radio-group': RadioGroup,
    'el-radio': Radio,
    'el-select': Select
  }
})
export default class StaffsList extends Mixins(Pagination) {
  @Prop({ required: true }) private customerOrganization!: CustomerOrganizationFields;

  private staff: organizationStaff_organizationStaff[] = [];
  private searchText = '';
  private addingMember = false;
  private rules = rules;
  private inviteInput: ShipperInvitationInput = {
    name: '',
    email: ''
  };

  private inviteFormLoading = false;
  private editInputId: string | null = null;
  private editInput: ShipperInput = {
    id: '',
    name: '',
    email: '',
    phoneNumber: '',
    language: null,
    emailNotifications: null
  };

  private editFormLoading = false;

  $refs!: {
    creationForm: HTMLFormElement;
    editForm: HTMLFormElement[];
  };

  private readonly languageOptions = languageOptions();

  private addMember(): void {
    this.inviteInput = {
      name: '',
      email: ''
    };
    this.addingMember = true;
  }

  private async addStaff() {
    this.$refs.creationForm.validate(async(valid: boolean) => {
      if (!valid) {
        return;
      }

      this.inviteFormLoading = true;
      try {
        const response = await shipperService.inviteNewShipperMutation(
          this.inviteInput,
          this.customerOrganization.id
        );

        if (response) {
          this.$apollo.queries.staff.refetch();
          this.$store.dispatch('Alert/addAlert', {
            type: 'success',
            message: this.$t('success.created'),
            time: 2000
          });
          this.inviteInput = {
            name: '',
            email: ''
          };
          this.addingMember = false;
        }
      } catch (error) {
        this.$store.dispatch('Alert/addAlert', {
          type: 'error',
          message: this.$t('error.push'),
          time: 2000
        });
      } finally {
        this.inviteFormLoading = false;
      }
    });
  }

  private async deleteStaff(shipper: ShipperInput) {
    if (!shipper.id ||
        !window.confirm(this.$t('customer.confirm.delete', { name: shipper.name }).toString())) {
      return;
    }

    try {
      const response = await shipperService.deleteShipper(shipper.id);

      if (response) {
        this.$apollo.queries.staff.refetch();
        this.$store.dispatch('Alert/addAlert', {
          type: 'success',
          message: this.$t('success.deleted'),
          time: 2000
        });
      }
    } catch (error) {
      this.$store.dispatch('Alert/addAlert', {
        type: 'error',
        message: this.$t('error.push'),
        time: 2000
      });
    }
  }

  private openStaffEdit(shipper: organizationStaff_organizationStaff) {
    this.editInputId = shipper.id;

    this.editInput = {
      id: shipper.id,
      name: shipper.name,
      email: shipper.email,
      phoneNumber: shipper.phoneNumber,
      language: shipper.language,
      emailNotifications: shipper.emailNotifications
    };
  }

  private async updateStaff() {
    this.$refs.editForm[0].validate(async(valid: boolean) => {
      if (!valid) {
        return;
      }
      this.editFormLoading = true;
      try {
        const response = await customerService.updateCustomer(this.editInput);
        if (response) {
          this.$apollo.queries.staff.refetch();
          this.$store.dispatch('Alert/addAlert', {
            type: 'success',
            message: this.$t('success.updated'),
            time: 2000
          });
          this.editInputId = null;
          this.editInput = {
            id: '',
            name: '',
            email: '',
            phoneNumber: '',
            language: null,
            emailNotifications: null
          };
        }
      } catch (error) {
        this.$store.dispatch('Alert/addAlert', {
          type: 'error',
          message: this.$t('error.push'),
          time: 2000
        });
      } finally {
        this.editFormLoading = false;
      }
    });
  }
}
